import React from "react";
import { makeStyles } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import { useTranslate } from "react-polyglot";

const useStyles = makeStyles(() => ({
  root: {
    position: "absolute",
    right: 6,
    bottom: 4,
    width: 24,
    height: 24,
    // Цвет соответствует green1 в палитре Android-приложения.
    color: "#226C36",
    pointerEvents: "none",
    zIndex: 1,
  },
}));

/**
 * Показывает зелёную галочку зачтённого урока в нижнем правом углу карточки.
 */
const LessonCompletedIcon = () => {
  const classes = useStyles();
  const t = useTranslate();

  return <CheckIcon className={classes.root} titleAccess={t("completed")} />;
};

export default LessonCompletedIcon;
